import React from 'react';
import PropTypes from 'prop-types'
import T from 'i18n-react';
import './topbar.css'
import classNames from 'classnames';
import Indicator from './Indicator'

const NavTab = ({ layoutType, propertyName, text, onClick, isSelected, showIndicator, indicatorValue }) => (
    <div className={classNames('workflow-topbar-navtab', layoutType, { 'workflow-topbar-navtab navtab-selected' : isSelected })} onClick={() => onClick(propertyName)}>
        <div className='workflow-topbar-navtab-label'>
            {T.translate(text)}
        </div>
        { showIndicator && <Indicator indicatorValue={indicatorValue} /> }
    </div>
);

NavTab.propTypes = {
    layoutType: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    showIndicator: PropTypes.bool,
    indicatorValue: PropTypes.number
}

export default NavTab;